/**
 * facett-page-text — h2 から目次を生成し、スクロール連動でアクティブ化
 * アンカー id は ASCII のみ（日本語 URL 断片を避ける）
 */
(function () {
  var ROOT_SEL = '[data-facett-page-text]';
  var MIN_HEADINGS = 1;
  var ASCII_ID_RE = /^[A-Za-z][A-Za-z0-9_-]*$/;

  function isAsciiId(id) {
    return ASCII_ID_RE.test(String(id || ''));
  }

  function slugify(text, index) {
    var base = String(text || '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .replace(/-+/g, '-')
      .slice(0, 64);

    if (!base) {
      return 'section-' + (index + 1);
    }

    /* 先頭が数字のみ等は CSS/HTML 的にも扱いづらいのでプレフィックス */
    if (!/^[a-z]/.test(base)) {
      base = 'section-' + base;
    }

    return base;
  }

  function uniqueId(base, used, currentEl) {
    var id = base || 'section';
    var n = 2;
    var candidate = id;
    while (used[candidate] || isTakenByOther(candidate, currentEl)) {
      candidate = id + '-' + n;
      n += 1;
    }
    used[candidate] = true;
    return candidate;
  }

  /* 自分自身の既存 id は衝突とみなさない（-2 誤付与防止） */
  function isTakenByOther(candidate, currentEl) {
    var el = document.getElementById(candidate);
    return !!(el && el !== currentEl);
  }

  function initRoot(root) {
    var toc = root.querySelector('[data-facett-page-toc]');
    var list = root.querySelector('[data-facett-page-toc-list]');
    var body = root.querySelector('.facett-page-text__body');
    if (!toc || !list || !body) return;

    var headings = Array.prototype.slice.call(body.querySelectorAll('h2'));
    if (headings.length < MIN_HEADINGS) {
      toc.hidden = true;
      root.classList.add('is-toc-empty');
      return;
    }

    var used = Object.create(null);
    var links = [];

    headings.forEach(function (heading, index) {
      var existing = heading.getAttribute('id');
      var base = isAsciiId(existing)
        ? existing
        : slugify(heading.textContent, index);
      var id = uniqueId(base, used, heading);
      heading.id = id;

      var li = document.createElement('li');
      li.className = 'facett-page-text__toc-item';

      var a = document.createElement('a');
      a.className = 'facett-page-text__toc-link';
      a.href = '#' + id;
      a.textContent = heading.textContent.replace(/\s+/g, ' ').trim();

      li.appendChild(a);
      list.appendChild(li);
      links.push({ heading: heading, link: a });
    });

    toc.hidden = false;

    if ('IntersectionObserver' in window) {
      var activeId = null;
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              activeId = entry.target.id;
            }
          });
          if (!activeId) return;
          links.forEach(function (item) {
            item.link.classList.toggle(
              'is-active',
              item.heading.id === activeId
            );
          });
        },
        {
          rootMargin: '-20% 0px -60% 0px',
          threshold: [0, 1],
        }
      );
      headings.forEach(function (heading) {
        observer.observe(heading);
      });
    }
  }

  function init() {
    document.querySelectorAll(ROOT_SEL).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
